import { QueryClient } from '@tanstack/react-query';
import { LoaderFunction } from 'react-router-dom';

import { assertDefined } from 'src/utils';

import { queries } from './queries';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export function loadContext<T>(): T {
  const element = document.getElementById('context-vars');
  return JSON.parse(element?.textContent ?? '{}') as T;
}

export type LoaderData<T> = T extends (...args: infer _A) => infer R
  ? R extends (...args: infer _A2) => infer R2
    ? Awaited<R2>
    : never
  : never;

export const loaders = {
  usecaseLoader: (queryClient) => {
    return async ({ params: { usecaseId } }) => {
      assertDefined(usecaseId);
      const query = queries.usecase(parseInt(usecaseId, 10));
      return queryClient.ensureQueryData(query);
    };
  },
  usecasesForStoreLoader: (queryClient) => {
    return async ({ params: { storeKey } }) => {
      assertDefined(storeKey);
      const query = queries.usecasesForStore(storeKey);
      return queryClient.ensureQueryData(query);
    };
  },
  spOptimizerStoresLoader: (queryClient) => {
    return async () => {
      const query = queries.spOptimizerStores();
      return queryClient.ensureQueryData(query);
    };
  },
  spOptimizerStoreExcludePhrases: (queryClient) => {
    return async ({ params: { spOptimizerStoreId } }) => {
      assertDefined(spOptimizerStoreId);
      const query = queries.spOptimizerStoreExcludePhrases(parseInt(spOptimizerStoreId, 10));
      return queryClient.ensureQueryData(query);
    };
  },
  spOptimizerStoreIncludePhrases: (queryClient) => {
    return async ({ params: { spOptimizerStoreId } }) => {
      assertDefined(spOptimizerStoreId);
      const query = queries.spOptimizerStoreIncludePhrases(parseInt(spOptimizerStoreId, 10));
      return queryClient.ensureQueryData(query);
    };
  },
  spOptimizerFlowMessageExperimentShardMetricsLoader: (queryClient) => {
    return async () => {
      const query = queries.spOptimizerFlowMessageExperimentShardMetrics();
      return queryClient.ensureQueryData(query);
    };
  },
  spOptimizerFlowMessageExperimentsForStoreLoader: (queryClient) => {
    return async ({ params: { storeKey } }) => {
      assertDefined(storeKey);
      const query = queries.spOptimizerFlowMessageExperimentsForStore(storeKey);
      return queryClient.ensureQueryData(query);
    };
  },
  spOptimizerFlowMessageExperimentsForSPOptimizerStoreLoader: (queryClient) => {
    return async ({ params: { spOptimizerStoreId } }) => {
      assertDefined(spOptimizerStoreId);
      const query = queries.spOptimizerFlowMessageExperimentsForSPOptimizerStore(parseInt(spOptimizerStoreId, 10));
      return queryClient.ensureQueryData(query);
    };
  },
} as const satisfies Record<string, (queryClient: QueryClient) => LoaderFunction>;
